import Seo from "@/components/Seo";
import { useEffect } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ProblemSection from "@/components/landing/ProblemSection";
import CaseStudySila from "@/components/landing/CaseStudySila";
import CentralizeSection from "@/components/landing/CentralizeSection";
import DiagnosticSection from "@/components/landing/DiagnosticSection";
import CaseStudyTaste from "@/components/landing/CaseStudyTaste";
import StandardVsCustom from "@/components/landing/StandardVsCustom";
import ProcessSection from "@/components/landing/ProcessSection";
import InvestmentSection from "@/components/landing/InvestmentSection";
import BookingCTA from "@/components/landing/BookingCTA";
import AboutSection from "@/components/landing/AboutSection";
import FAQSection from "@/components/landing/FAQSection";
import FinalCTA from "@/components/landing/FinalCTA";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import InlineCTA from "@/components/landing/InlineCTA";
import MobileStickyCTA from "@/components/landing/MobileStickyCTA";

export default function Landing() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 400);
      return () => clearTimeout(t);
    }
  }, []);
  return (
    <div className="noise relative">
      <Seo path="/" />
      <Header />
      <main id="main">
        <Hero />
        <ProblemSection />
        <CaseStudySila />
        <InlineCTA
          variant="lead"
          testid="inline-cta-after-sila"
          title="Riconosci questi colli di bottiglia nella tua azienda?"
          cta="Richiedi un'analisi"
        />
        <CentralizeSection />
        <DiagnosticSection />
        <CaseStudyTaste />
        <InlineCTA
          variant="book"
          testid="inline-cta-after-taste"
          title="Parliamo del tuo caso in una call dedicata"
        />
        <StandardVsCustom />
        <ProcessSection />
        <InvestmentSection />
        <BookingCTA />
        <AboutSection />
        <InlineCTA
          variant="book"
          testid="inline-cta-after-about"
          title="Pochi progetti, seguiti bene"
          subtitle="Seleziono massimo 4 progetti l'anno · prenota ora il tuo posto."
        />
        <FAQSection />
        <FinalCTA />
        <ContactSection />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
